<template>
  <div class="element-processor" :style="onlyConsultVer?'margin-bottom: -3.5rem;':''">
    <header v-if="!onlyConsultVer && data.steps[currentStep].title !== '상담 예약'">
      <h1>{{ data.title }}</h1>
      <p @click="cancelProcessor" class="cancelButton"></p>
    </header>
    <div class="dimmer" v-if="$store.state.dimmer"></div>
    <aside v-if="asideVisible">
      <ul>
        <template v-if="data.cureData">
          <!-- 치료이력 탭 제외시 공통 적용을 위해 for에서 제외 시킴 20210107-->
          <li v-if="i < data.steps.length - 2 && step.title !== '치료이력'" :class="{ on: currentStep == i, completed: currentStep > i }" v-for="( step, i ) in data.steps">
            <span class="step-index">{{ i>2?i:i+1 }}</span>
            <span class="step-title">{{ step.title }}</span>
          </li>
        </template>
        <template v-else>
          <li v-if="i < data.steps.length - 2" :class="{ on: currentStep == i, completed: currentStep > i }" v-for="( step, i ) in data.steps">
            <span class="step-index">{{ i+1 }}</span>
            <span class="step-title">{{ step.title }}</span>
          </li>
        </template>
      </ul>
    </aside>

    <main :style=" asideVisible? '' : (onlyConsultVer?'min-height: 100%; margin-left: 0;':'margin-left: 0;') "><!--v-bind:style="{ marginLeft: asideVisible ? '20rem' : '0px' } "-->
      <h2 v-show="false">{{ data.steps[ currentStep ].title }}</h2>
      <div class="body">
        <form spellcheck="false" @submit.prevent>
          <slot />
        </form>
      </div>
    </main>

    <footer v-if="!onlyConsultVer" :style="{
      marginLeft: (asideVisible? '':'0'),
      visibility: (data.steps[ currentStep ].title == '본인 확인'? 'hidden':'')
    }">

      <template v-if="data.title.indexOf('상담 예약') == -1 && data.title != '서비스신청' && data.title !== '알릴의무'">
        <template v-if="currentStep == 0">
          <button type="button" @click="cancelProcessor">취소</button>
          <button type="button" @click="nextStep" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">다음</button>
        </template>

        <template v-else-if="(data.steps[ currentStep ].title == '가입자' || data.steps[ currentStep ].title == '본인 확인') ">
          <!-- <button type="button" @click="previousStep">이전</button>
          <button type="button" @click="submitProcessor" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">비교견적 신청</button> -->
        </template>

        <template v-else-if="currentStep == data.steps.length - 3">
          <!--<button type="button" @click="previousStep">이전</button>-->
          <button type="button" @click="submitProcessor" style="width:100%;" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">신청</button>
        </template>
        <template v-else-if="currentStep == data.steps.length - 2">
          <button type="button" @click="doneProcessor()" style="width:100%;" class="complete">확인</button>
        </template>
        <template v-else-if="currentStep == data.steps.length - 1">
          <button type="button" @click="SubmitOtherEstimate" style="width:100%;" class="complete">확인</button>
        </template>
        <template v-else>
          <button type="button" @click="previousStep">이전</button>
          <button type="button" @click="nextStep" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">다음</button>
        </template>
      </template>
      <template v-else-if="data.title == '서비스신청'">
        <template v-if="currentStep == 0">
          <button type="button" @click="submitProcessor" style="width:100%;" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">신청</button>
        </template>
        <template v-else>
          <button type="button" @click="doneProcessor()" style="width:100%;" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">확인</button>
        </template>

      </template>
      <template v-else-if="data.title == '(선택)전화 상담 예약 변경'">
        <template v-if="currentStep == 0">
          <button type="button" @click="submitProcessor" style="width:100%;" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">예약 변경</button>
        </template>
        <template v-else>
          <button type="button" @click="doneProcessor()" style="width:100%;" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">확인</button>
        </template>
      </template>

      <template v-else-if="data.title === '알릴의무'">
        <template v-if="currentStep === 0">
          <button type="button" @click="cancelProcessor">취소</button>
          <button type="button" @click="nextStep" :style="availableNext ? 'background-color: #174be6' : ''" :class="{ available: availableNext }">다음</button>
        </template>

        <template v-else-if="currentStep === data.steps.length - 2">
          <button type="button" @click="previousStep">이전</button>
          <button type="button" @click="submitProcessor" :style="availableNext ? 'background-color: #174be6' : ''" :class="{ available: availableNext }">등록</button>
        </template>

        <template v-else-if="currentStep === data.steps.length - 1">
          <button type="button" @click="doneProcessor()" style="width:100%;" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">확인</button>
        </template>

        <template v-else>
          <button type="button" @click="previousStep">이전</button>
          <button type="button" @click="nextStep" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">다음</button>
        </template>
      </template>

      <template v-else>
        <template v-if="currentStep == 0">
          <button type="button" @click="submitProcessor" style="width:100%;" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">예약</button>
        </template>
        <template v-else>
          <button type="button" @click="doneProcessor()" style="width:100%;" :style=" availableNext ? 'background-color: #174be6' : '' " :class="{ available: availableNext }">확인</button>
        </template>

      </template>
    </footer>
  </div>
</template>

<style lang="scss">

  .element-processor{
    .cancelButton{
      width:2rem;
      height:2rem;
      background-image: url(/static/images/connection/close-white.png);
      background-size: 1.2*$unit;
      background-repeat: no-repeat;
      background-position: center right;
      font-size: 16px;
      font-weight: 600;
      position: absolute;
      right: 20px;
      top: 2rem;
      cursor: pointer;
    }
  }

</style>

<script>

import { modalItems } from "@/router/routes";
import moment from "moment";
export default {
  props: [ "data" ],
  data(){
    return {
      availableNext: false,
      currentStep: 0,
      asideVisible: false,
      onlyConsultVer: false,
      isFirstClick: false
    }
  },
  created() {

    this.$store.commit( "SET_DIMMER", false );
    if(this.data.title.indexOf('상담 예약') >= 0 || this.data.title === "서비스신청"){

      this.asideVisible = false;

    }
    if(this.data.status !== undefined && this.data.status.indexOf('onlyConsultVer') >= 0){
       this.onlyConsultVer = true
    }
  },
  computed: {
    currentStepComponent(){
      return this.$children ? this.$children[ this.currentStep ] : null;
    }
  },
  mounted(){
    if(this.$route.query && this.$route.query.step) {
      var data = this.$children.map( o => o.data ? o.data : {} ).length;
      this.currentStep = data - 3
    }
    this.$watch( "currentStep", step => {
      this.$children.forEach( o => {
        o.isVisible = false;
      });
      this.currentStepComponent.isVisible = true;
      setTimeout(() => {
        window.scrollTo( 0, 0 );
        this.$store.commit( "SET_PAGENAME", { name : this.currentStepComponent.data.title }); //( step + 1 ) + ". " +

        this.$watch( "currentStepComponent.data", ( newData, oldData ) => {
          if( newData && newData.formData ){
            this.validate( false );
          };
        }, { immediate: true, deep: true });

        
        if (!this.$route.query.t) {
          this.resizeEventHandler();
        }
      });

      if (step === 5) {
        this.getAvatar();
      }

      this.$emit('updateCurrentStep', step);
      
    }, { immediate: true });

    if (!this.$route.query.t) {
      window.addEventListener('resize', this.resizeEventHandler);
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeEventHandler);
  },
  methods: {
    cancelProcessor(){

      if( modalItems[ this.$route.name ] ){
        if( document.referrer ){
          this.$router.push({ name: "Home" });
        }else{
          history.back();
        };
      }else{
        this.$store.commit( "elementModal/CLEAR_ITEMS" );
        var tab = this.$route.query.tab;
        this.$router.replace({ query: { tab : tab}})
      }
    },
    doneProcessor(page) {
      /*if( modalItems[ this.$route.name ] ){
        if( document.referrer ){
          this.$router.replace({ name: "Home" });
        }else{
          history.back();
        };
      }else{
        this.$store.commit( "elementModal/CLEAR_ITEMS" );
      }*/
      this.$store.commit( "elementModal/CLEAR_ITEMS" );
      if(page){

        this.$router.push({ name: page })
      }else{
        this.$router.push({ name: "Home" })
      }
      
    },
    SubmitOtherEstimate() {

      var data = this.$children.map( o => o.data ? o.data : {} );

      var oestdata = data.find(o => o.title == "다른 보험 표준 견적서 받아보기")
      if(oestdata.value.length == 0){
        alert("하나 이상 선택하셔야 합니다.")
      }else{
        this.$emit("submitOtherEst")

        this.doneProcessor()
      }
    },
    submitProcessor(){
      var formData = this.$children[ this.currentStep ].data.formData;
      /*var d = new Date();
      var target_date = moment(formData.consultDate.value).format('YYYYMMDD');
      var now_date = moment(d).format('YYYYMMDD');

      if (target_date - now_date == 0) {
        if( formData.consultTime.value.substr(0,2) < d.getHours() ){
          alert("이전 시간으로 예약하실 수 없습니다.")
          return
        }else if (formData.consultTime.value.substr(0,2) == d.getHours() && formData.consultTime.value.substr(3,2) <= d.getMinutes()) {
          alert("이전 시간으로 예약하실 수 없습니다.")
          return
        }
      }*/


      if( this.validate() ){
        /* 양식 제출 */
        /* 기존 코드
        var data = this.$children.map( o => o.data.formData ? o.data.formData : {} );
        var finalData = {};
        data.forEach( o => {
          Object.keys( o ).forEach( p => {
            finalData[ p ] = o [ p ].value;
          });
        });
        */
        var finalData = {};
        /*  데이터 저장 예 */
        /*
         {
            "process_step_KeyName": {
              "step_title" : "process step 한글 명 (예 : 기본정보, 보장항목 등)",
              "step_datas" : {
                "step_data_KeyName1": {
                  "title": "데이터 명(예 : 이름, 생년월일 등)",
                  "value": "값(예: 홍길동, 000000) 또는 배열"
                },
                "step_data_KeyName2": {
                  "title": "데이터 명(예 : 이름, 생년월일 등)",
                  "value": "값(예: 홍길동, 000000) 또는 배열"
                }
              }
            }
          }
        */
        var data = this.$children.map( o => o.data ? o.data : {});

        finalData["title"] = this.data.title
        data.forEach( o => {
          var process_step = {
            step_title: "",
            step_datas: {}
          };
          if(o.formData) {
            if(o.title) process_step.step_title = o.title; // STEP 명 (ex : 기본정보, 보장항목 등)
            var tmp_step_datas = Object.keys(o.formData) // Step의 항목들
            tmp_step_datas.forEach( s => {
              // 가끔 formData 값들중 Array 기반 값이 있으므로 확인해야함. (예: 보장항목 과 추가특약 을 담고있는 object)
              if( Array.isArray(o.formData[s]) ){
                process_step.step_datas[s] = []
                o.formData[s].forEach(i => {
                  if(i.use == undefined || i.use === true) {
                    // 이런경우 Key 가 겹치게 됨
                    // process_step.step_datas[s] = { title: i.label, value: i.value }

                    // 배열형태로 전달
                    process_step.step_datas[s].push({ title: i.label, value: i.value })

                  }
                })
              }else{
                // 사용 여부에 따라 추가
                if(o.formData[s].use == undefined || o.formData[s].use === true) {
                  process_step.step_datas[s] = { title: o.formData[s].label, value: o.formData[s].value }
                  //process_step.step_datas.push({ title: o.formData[s].label, value: o.formData[s].value })
                }
              }

            })
            finalData[o.title] = process_step
            // finalData.push(process_step)
          }

        });

        /* ? */
        /*
          var userdata = {}
          if( this.$store.state.customer.profile._id ){
            userdata.profile = this.$store.state.customer.profile;
          }

          if(this.$children[0].data.title === '차량 기본정보'){
            userdata.autoCode = this.$children[1].data.formData.detailInformation.code;
          }


        */
        /* ? */

        // TEST
        /*var fnd_iter = [];
        fnd_iter.push(this.$store.state.customer.profile._id)
        for(var i = 0; i < finalData.length; i++){
          var step_data = finalData[i].step_data;
          step_data.forEach(o => {
            fnd_iter.push(o.value)
          })
        }*/

        //finalData.push({customer_id: this.$store.state.customer.profile._id});
        finalData.customer_id = this.$store.state.customer.profile.customer_id?this.$store.state.customer.profile.customer_id:this.$store.state.customer.profile._id
        Object.keys(finalData).forEach(item => {
          if(item.indexOf("상담 예약") != -1){
            if(finalData[item].step_datas.consultRemark.value === "") finalData[item].step_datas.consultRemark.value = "없음"
          }
        });

        // 치료이력 기본값 없음으로 셋팅 20210107
        if(finalData["치료이력"]){
          if(finalData["치료이력"].step_datas.history) finalData["치료이력"].step_datas.history.value = "없음"
          if(finalData["치료이력"].step_datas.inject) finalData["치료이력"].step_datas.inject.value = "없음"
          if(finalData["치료이력"].step_datas.have) finalData["치료이력"].step_datas.have.value = "없음"
          if(finalData["고객 정보"] && finalData["고객 정보"].step_datas.birth) finalData["치료이력"].step_datas.birth.value = finalData["고객 정보"].step_datas.birth.value
          
          //치매보험 전용
          if(finalData["치료이력"].step_datas.history_3years) finalData["치료이력"].step_datas.history_3years.value = "없음"
          if(finalData["치료이력"].step_datas.history_5years) finalData["치료이력"].step_datas.history_5years.value = "없음"
          if(finalData["치료이력"].step_datas.history_dementia_years) finalData["치료이력"].step_datas.history_dementia_years.value = "없음"
          if(finalData["치료이력"].step_datas.history_dementia_5years) finalData["치료이력"].step_datas.history_dementia_5years.value = "없음"
          
        }
        if(finalData["상담 예약"])
          if(finalData["상담 예약"].step_datas.consultRemark.value === "") finalData["상담 예약"].step_datas.consultRemark.value = "없음"
        if(finalData["전화상담"])
          if(finalData["전화상담"].step_datas.consultRemark.value === "") finalData["전화상담"].step_datas.consultRemark.value = "없음"
        if(finalData["서비스 신청하기"])
          if(finalData["서비스 신청하기"].step_datas.consultRemark.value === "") finalData["서비스 신청하기"].step_datas.consultRemark.value = "없음"
        // this.$emit( "submit", {...fnd_iter});
        this.$emit( "submit", finalData);
        this.nextStep();
      }else{
      }
    },
    previousStep(){
      if(this.currentStep === 3 && this.data.cureData){
        this.currentStep = this.currentStep - 2
      }else{
        this.currentStep--;
      }
    },
    nextStep(){
      if( this.validate(true, this.$children[ this.currentStep ].proxy_data) ){
        if(this.currentStep === 1 && this.data.cureData){
          this.currentStep = this.currentStep + 2
        }else{
          this.currentStep++;
        }

        if (this.currentStep === 1 && !this.isFirstClick) {
          this._nasa();
        }
        this.isFirstClick = true;
      };
    },
    forceBlockNextStep() {
      this.currentStep++;
    },
    checkAge(birth) {
      const birthYY = birth.substr(0, 4);
      const birthMD = birth.substr(4);
      
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      let month = (currentDate.getMonth() + 1);
      let day = currentDate.getDate();
      month = month < 10 ? '0' + month : String(month);
      day = day < 10 ? '0' + day : String(day);
      const md = month + day;

      let age = year - birthYY;

      if (md < birthMD) {
        age = age - 1
      }
      
      return age;
    },
    validate( setError = true, proxy_data = null){
      var result = true;
      var formData = this.$children[ this.currentStep ].data.formData;

      if(proxy_data) formData = proxy_data;
      Object.values( formData ).forEach( o => {
        if( !this.validateField( o, setError ) ) result = false;
      });
      this.availableNext = result;
      this.$forceUpdate();
      return result;
    },
    validateField( ob, setError ){
      var result = null;
      if(Array.isArray(ob)){
        var check_rst = 0;
        ob.forEach(_o => {
          if( !_o.validations || (_o.use === false) ) return true;
          result = null;
          _o.validations.forEach( o => {
            if( o.type.split( ":" ).length > 1 ){
              var vn = o.type.split( ":" )[0];
              var vv = o.type.split( ":" )[1];
              switch( vn ){
                case "min" :
                  if( _o.value.length < vv ){
                    result = o.message;
                  };
                break;
                case "max" :
                  if( _o.value.length > vv ){
                    result = o.message;
                  };
                break;
                case "matchField" :
                  if( _o.value != this.formData[vv].value ){
                    result = o.message;
                  };
                break;
                case "matchString" :
                  if( _o.value != vv ){
                    result = o.message;
                  };
                break;
              };
            }else{
              var vn = o.type;
              switch( vn ){
                case "email" :
                  var regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                  if( !regExp.test( _o.value ) ){
                    result = o.message;
                  };
                break;
                case "required" :
                  if((typeof _o.value != "number" && !_o.value)){
                    result = o.message;
                  };

                  if (typeof _o.value === 'object' && _o.label === '추천 특약') {
                    const { birth } = this.$children[0].data.formData;
                    const isBirthMore = this.checkAge(birth.value) > 29 ? true : false;
                    const isNoJoin = _o.value.findIndex(ov => ov.value !== '미가입') !== -1;
                    
                    setError = true;

                    if (!isBirthMore) {
                      return;
                    }

                    result = !isNoJoin ? o.message : '';
                  }
                break;
                case "number" :
                  var regExp = /^[0-9]*$/;
                  if( !regExp.test( _o.value ) ){
                     _o.value = "";
                    result = o.message;
                  };

                break;
                case "birth" :
                  //6자리만 입력되도로 정규화
                  const { length = 6 } = ob;

                  if (ob.value.length > length) {
                    ob.value = ob.value.substr(0, length)
                  }
                  //숫자 입력되로고 정규화 추가
                  var regNumber = /^[0-9]*$/;
                  if (!regNumber.test(ob.value)) {
                    ob.value = "";
                  }

                  var regExp = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;

                  if (length === 8) {
                    regExp = /^(?:[1-9]{1}(?:[0-9]{3})(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;
                  }
                  if( !regExp.test( ob.value ) ){
                    result = o.message;
                  };
                break;
                case "array" :
                  if( _o.value.length == 0 ){
                    result = o.message;
                  }
                  break;
                case "float" :
                  //소수점
                  var reg = /^\d+(\.\d+)?$/;
                  for(var i = 0; i < _o.value.length; i++){
                    if (!reg.test(_o.value[i].value)) {
                      _o.value[i].value = ""
                      result = o.message;
                    }
                  }
                  break;
              };
            }
          })

          if( result ){
            if( setError ) _o.error = result;
            check_rst++;
          }else{
            if( setError ) _o.error = null;
          }
        })

        if(check_rst > 0){
          return false;
        }else{
          return true;
        }
      }else{
        if( !ob.validations || (ob.use === false) ) return true;
        result = null;
        ob.validations.forEach( o => {
          if( o.type.split( ":" ).length > 1 ){
            var vn = o.type.split( ":" )[0];
            var vv = o.type.split( ":" )[1];
            switch( vn ){
              case "min" :
                if( ob.value.length < vv ){
                  result = o.message;
                };
              break;
              case "max" :
                if( ob.value.length > vv ){
                  result = o.message;
                };
              break;
              case "matchField" :
                if( ob.value != this.formData[vv].value ){
                  result = o.message;
                };
              break;
              case "matchString" :
                if( ob.value != vv ){
                  result = o.message;
                };
              break;
            };
          }else{
            var vn = o.type;
            switch( vn ){
              case "email" :
                var regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                if( !regExp.test( ob.value ) ){
                  result = o.message;
                };
              break;
              case "required" :
                if( typeof ob.value != "number" && !ob.value ){
                  result = o.message;
                };
              break;
              case "number" :
                var regExp = /^[0-9]*$/;
                if( !regExp.test( ob.value ) ){
                  result = o.message;
                };
              break;
              case "birth" :
                //6자리만 입력되도로 정규화
                const { length = 6 } = ob;

                if (ob.value.length > length) {
                  ob.value = ob.value.substr(0, length)
                }
                //숫자 입력되로고 정규화 추가
                var regNumber = /^[0-9]*$/;
                if (!regNumber.test(ob.value)) {
                  ob.value = "";
                }

                var regExp = /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;

                if (length === 8) {
                  regExp = /^(?:[1-9]{1}(?:[0-9]{3})(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))$/;
                }
                if( !regExp.test( ob.value ) ){
                  result = o.message;
                };
              break;
              case "array" :
                if( ob.value.length == 0 ){
                  result = o.message;
                }
                break;
              case "float" :
                //소수점
                var reg = /^\d+(\.\d+)?$/;
                for(var i = 0; i < ob.value.length; i++){
                  if (!reg.test(ob.value[i].value)) {
                    ob.value[i].value = ""
                    result = o.message;
                  }
                }
                break;
            };
          };
        });

        if( result ){
          if( setError ) ob.error = result;
          return false;
        }else{
          if( setError ) ob.error = null;
          return true;
        }
      }

    },
    getAvatar() {
      this.$store.dispatch('etc/getAdmin').then(res => {
        const { data, error } = res.data;

        if (error) {

        }
        
        this.$emit('getAdminRand', data);
      });
    },
    resizeEventHandlerByTablet() {
      const $modal = document.querySelector('#site-container');
      const $main = document.querySelector('main');
      const $footer = document.querySelector('footer');
      const DIFF = (6.14 * 14) + 84 + 56 + 28 // header, processor header, footer, footer padding top
      let height = $modal.clientHeight - DIFF;
      let overflow = 'hidden auto';

      if (this.data.steps[this.currentStep].title === '본인 확인') {
        const DIFF2 = this.$route.meta.name === '자동차보험 견적서' ? 161 : 119;
        height = height + 84;
        overflow = 'hidden';
        document.querySelector('.element-auth').style.paddingBottom = 0;
        document.querySelector('.element-auth > main').style.height = `${height - DIFF2}px`; // 161: footer, 56: main padding
        document.querySelector('.fixed-footer > .buttons > button').style.marginBottom = 0;
        $main.style.paddingBottom = 0;
      }

      if (this.data.steps[this.currentStep].title === '상담 예약') {
        height = height + 84;
      }

      $main.style.height = `${height}px`;
      $main.style.overflow = overflow;

      $footer.style.paddingBottom = 0;
    },
    resizeEventHandlerByMobile() {
      const width = window.innerWidth;
      const $modal = document.querySelector('#site-container');
      const DIFF = (6.14 * 14) + 56 + 14 // header, footer, footer padding top
      const $main = document.querySelector('main');
      const $footer = document.querySelector('footer');
      let height = $modal.clientHeight - DIFF;
      let overflow = 'hidden auto';

      if (width > 999) {
        return this.resizeEventHandlerByTablet();
      }

      if (this.data.steps[this.currentStep].title === '본인 확인') {
        height = height + 70;
        
        const DIFF2 = this.$route.meta.name === '자동차보험 견적서' ? 161 : 119;
        const height2 = height - DIFF2;
        
        overflow = 'hidden';
        document.querySelector('.element-auth').style.paddingBottom = 0;
        document.querySelector('.element-auth > main').style.height = `${height2}px`; // 161/119: footer, 56: main padding

        if (height2 < 516) {
          document.querySelector('.element-auth > main').style.overflow = 'hidden auto';
        }
        document.querySelector('.fixed-footer > .buttons > button').style.marginBottom = 0;
        $main.style.paddingBottom = 0;
      }

      $main.style.height = `${height}px`;
      $main.style.overflow = overflow;

      $footer.style.paddingBottom = 0;
    },
    resizeEventHandler() {
      const isMobile = this.$store.state.config.isTouchDevice;

      if (isMobile) {
        // return this.resizeEventHandlerByMobile();
        return;
      }
      
      const $modal = document.querySelector('.element-modal');
      const $main = document.querySelector('main');
      const DIFF = 84 + 112 + 56 //header + footer + footer padding
      const height = $modal.clientHeight - DIFF;

      if (this.data.steps[this.currentStep].title === '본인 확인') {
        const DIFF2 = this.data.title === '자동차보험 견적서' ? 161 : 119;
        document.querySelector('.element-auth > main').style.height = `${height - DIFF2 - 56}px`; // 161: footer, 56: main padding
      }

      $main.style.height = `${height}px`;
      $main.style.overflow = 'hidden auto';
    },
    _nasa(){
      var sh = document.getElementById("site-header")
      var tag = document.createElement('script')
      tag.src = "https://wcs.naver.net/wcslog.js"
      tag.type = "text/javascript"
      tag.async = true
      tag.onload = function(){
        var code_tag = document.createElement('script')
        code_tag.text = `
          var _nasa={};
          if(window.wcs) _nasa["cnv"] = wcs.cnv("1","10");
        `;
        sh.appendChild(code_tag)
      }
      sh.appendChild(tag);

      console.log('ssss')
    },
  }
}
</script>
